__turbopack_context__.v({
  "contactButton": "style-module-scss-module__qoCJHa__contactButton",
  "contactButtonText": "style-module-scss-module__qoCJHa__contactButtonText",
  "contactButtonWrapper": "style-module-scss-module__qoCJHa__contactButtonWrapper",
  "logo": "style-module-scss-module__qoCJHa__logo",
  "menuButton": "style-module-scss-module__qoCJHa__menuButton",
  "menuButtonText": "style-module-scss-module__qoCJHa__menuButtonText",
  "menuButtonWrapper": "style-module-scss-module__qoCJHa__menuButtonWrapper",
});
